import React, { Component, createRef } from 'react';
import Menu from './cmdMenu'
import cmd from '../photos/cmd.PNG';

class CMD extends Component {
	constructor(props) {
		super(props);

		this.cmdRef = createRef();
		this.titleRef = createRef();

		this.state = {
			width: 0,  // will be set on mount dynamically
			height: 0,
		};

		this.baseWidth = 0;  
  		this.baseHeight = 0;
		
		this.bringToFront = this.bringToFront.bind(this);
		this.closeApp = this.closeApp.bind(this);
	}

	componentDidMount() {
		const dragTarget = this.cmdRef.current; // or cmdRef, etc.
		const dragHandle = this.titleRef.current;
		const resizeHandle = dragTarget.querySelector('.resize-handle');
		
		// Measure initial size in pixels from actual DOM element
		const rect = dragTarget.getBoundingClientRect();
		
		this.baseWidth = rect.width;
  		this.baseHeight = rect.height;

		this.setState({
			width: rect.width,
			height: rect.height,
		});

		let isDragging = false;
		let isResizing = false;
		let startX = 0;
		let startY = 0;
		let initialLeft = 0;
		let initialTop = 0;
		let startWidth = 0;
		const DRAG_THRESHOLD = 5;

		// --- Drag logic ---
		const onMouseDown = (e) => {
			startX = e.clientX;
			startY = e.clientY;

			// Save the initial position of the window
			initialLeft = dragTarget.offsetLeft;
			initialTop = dragTarget.offsetTop;

			document.addEventListener('mousemove', onMouseMove);
			document.addEventListener('mouseup', onMouseUp);
		};

		const onMouseMove = (e) => {
			const dx = e.clientX - startX;
			const dy = e.clientY - startY;

			// Only start dragging after threshold
			if (!isDragging && (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD)) {
				isDragging = true;
			}

			if (!isDragging) return;

			// Update the window's position based on mouse movement delta
			dragTarget.style.left = `${initialLeft + dx}px`;
			dragTarget.style.top = `${initialTop + dy}px`;
		};

		const onMouseUp = () => {
			isDragging = false;
			document.removeEventListener('mousemove', onMouseMove);
			document.removeEventListener('mouseup', onMouseUp);
		};

		dragHandle.addEventListener('mousedown', onMouseDown);

		// --- Resize logic ---
		const onResizeMouseDown = (e) => {
			isResizing = true;
			startX = e.clientX;
			startY = e.clientY;
			startWidth = dragTarget.offsetWidth;

			document.addEventListener('mousemove', onResizeMouseMove);
			document.addEventListener('mouseup', onResizeMouseUp);

			e.preventDefault();
		};

		const aspectRatio = this.baseWidth / this.baseHeight;

		const MIN_WIDTH = 350;
		const MIN_HEIGHT = 200;
		const MAX_WIDTH = 600;
		const MAX_HEIGHT = 400;

		const onResizeMouseMove = (e) => {
			if (!isResizing) return;

			const deltaX = e.clientX - startX;
			const deltaY = e.clientY - startY;

			// Pick the dominant delta (horizontal or vertical)
			const delta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;

			let newWidth = startWidth + delta;
			let newHeight = newWidth / aspectRatio;

			// Clamp width and height to both min and max
			newWidth = Math.max(MIN_WIDTH, Math.min(MAX_WIDTH, newWidth));
			newHeight = Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, newHeight));

			this.setState({
				width: newWidth,
				height: newHeight,
			});
		};

		const onResizeMouseUp = () => {
			isResizing = false;
			document.removeEventListener('mousemove', onResizeMouseMove);
			document.removeEventListener('mouseup', onResizeMouseUp);
		};

		resizeHandle.addEventListener('mousedown', onResizeMouseDown);
	}

	bringToFront() {
		document.getElementById('cmdApp').style.zIndex = 2;
		document.getElementById('streamPageApp').style.zIndex = 1;
		document.getElementById('storePageApp').style.zIndex = 1;
		document.getElementById('aboutPageApp').style.zIndex = 1;
		document.getElementById('contactPageApp').style.zIndex = 1;
		document.getElementById('clipApp1').style.zIndex = 1;
		document.getElementById('clipApp2').style.zIndex = 1;
	}

	closeApp() {
		document.getElementById('cmdApp').style.zIndex = 1;
        document.getElementById('cmdApp').style.visibility = 'hidden';
    }

	render() { 
		const { width, height } = this.state;

		const baseWidth = this.baseWidth || 600;
		const baseHeight = this.baseHeight || 400;

		const scaleX = width / baseWidth;
		const scaleY = height / baseHeight;
		const scale = Math.min(scaleX, scaleY);

		const style = {
			overflow: 'hidden',
			...(this.state.width && this.state.height
				? { width: this.state.width, height: this.state.height }
				: {}) // fallback to CSS % sizing
		};

		return (
			<div 
				id="cmdApp" 
				ref={this.cmdRef}
				className="appWindow"
				onClick={this.bringToFront}
				style={style}
			>
				<div 
					id="cmdtitlearea"
					ref={this.titleRef}
				>
					<div id="cmd-img">
						<img id="cmdApp-img" src={cmd} alt="App Icon"/>
					</div>
					<div id="cmd-title"><b> Command Prompt </b></div>
					<div className='closeButton' onClick={this.closeApp}>X</div>
				</div>

				<div 
					id="cmdContentWrapper"
					style={{
					transform: `scale(${scale})`,
					transformOrigin: 'top left',
					width: baseWidth,
					height: baseHeight,
					position: 'relative',
					}}
				>
					<div id="cmd-program">
						Microsoft Windows [Version 10.0.10240] <br />
						(c) 2015 Microsoft Corporation. All rights reserved.
					</div>
					<Menu />
				</div>

				<div className="resize-handle" />
			</div>
		);
	}
}
 
export default CMD;